import { Box } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useEffect, useState } from "react";
import {
  CatalogFilter,
  ListRequestOfCatalogFilter,
} from "services/organizationPortalClient";
import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import SeriesFilter from "./SeriesFilter";
import SeriesTile from "./SeriesTile";
import {
  TileTable,
  DEFAULT_TILE_TABLE_PAGE_SIZE,
  RoundedBox,
} from "@knowfully/ui.common";
import contextStore from "stores/contextStore";

export default function SeriesTab() {
  const { formatMessage: t } = useIntl();
  const { catalogService } = useGlobalContext();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_TILE_TABLE_PAGE_SIZE);
  const [filter, setFilter] = useState({} as CatalogFilter);
  const { organization } = contextStore.useState();

  const { data, isLoading } = useQuery(
    ["getSeries", organization?.id, page, rowsPerPage, filter],
    () =>
      catalogService.getSeries(
        ListRequestOfCatalogFilter.fromJS({
          pageNumber: page,
          pageSize: rowsPerPage,
          parameters: filter,
        })
      ),
    { keepPreviousData: true }
  );

  useEffect(() => {
    setPage(0);
  }, [filter]);

  return (
    <Box>
      <RoundedBox>
        <SeriesFilter onChange={setFilter} />
      </RoundedBox>
      <RoundedBox>
        <TileTable
          {...{
            "aria-label": t({ id: "seriesCatalog" }),
            isLoading: isLoading,
            rowCount: data?.totalRecords ?? 0,
            data: data?.data ?? [],
            page,
            setPage,
            rowsPerPage,
            setRowsPerPage,
            renderTileComponent: SeriesTile,
          }}
        />
      </RoundedBox>
    </Box>
  );
}
